
import { addAnnouncement, deleteAnnouncement, getAnnouncementById, getAnnouncements, updateAnnouncement } from "app/redux/api";
import { FAILURE, REQUEST, SUCCESS, ANNOUNCEMENTS_ACTION_TYPE } from "../utilities";

export const CREATE_ANNOUNCEMENTS = (data, token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(ANNOUNCEMENTS_ACTION_TYPE.CREATE_REQUEST));
    addAnnouncement(data, token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(ANNOUNCEMENTS_ACTION_TYPE.CREATE_SUCCESS, response.data.data)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        ANNOUNCEMENTS_ACTION_TYPE.CREATE_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(ANNOUNCEMENTS_ACTION_TYPE.CREATE_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};

export const GET_ALL_ANNOUNCEMENTS = (filters, token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(ANNOUNCEMENTS_ACTION_TYPE.GET_REQUEST));

    getAnnouncements(filters, token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(ANNOUNCEMENTS_ACTION_TYPE.GET_SUCCESS, response.data.data)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        ANNOUNCEMENTS_ACTION_TYPE.GET_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(ANNOUNCEMENTS_ACTION_TYPE.GET_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};

export const GET_BY_ID_ANNOUNCEMENTS = (id, token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(ANNOUNCEMENTS_ACTION_TYPE.GET_BY_ID_REQUEST));

    getAnnouncementById(id, token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(ANNOUNCEMENTS_ACTION_TYPE.GET_BY_ID_SUCCESS, response.data.data)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        ANNOUNCEMENTS_ACTION_TYPE.GET_BY_ID_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(ANNOUNCEMENTS_ACTION_TYPE.GET_BY_ID_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};

export const UPDATE_ANNOUNCEMENTS = (id, data, token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(ANNOUNCEMENTS_ACTION_TYPE.UPDATE_REQUEST));

    updateAnnouncement(id, data, token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(ANNOUNCEMENTS_ACTION_TYPE.UPDATE_SUCCESS, response.data.data)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        ANNOUNCEMENTS_ACTION_TYPE.UPDATE_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(ANNOUNCEMENTS_ACTION_TYPE.UPDATE_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};

export const DELETE_ANNOUNCEMENTS = (id,  token, moveToNext, failure) => async (dispatch) => {
    dispatch(REQUEST(ANNOUNCEMENTS_ACTION_TYPE.REMOVE_REQUEST));

    deleteAnnouncement(id,  token).then(
        (response) => {
            if (response.data.succeeded) {
                dispatch(
                    SUCCESS(ANNOUNCEMENTS_ACTION_TYPE.REMOVE_SUCCESS, id)
                );
                if (moveToNext) moveToNext();
            } else {
                dispatch(
                    FAILURE(
                        ANNOUNCEMENTS_ACTION_TYPE.REMOVE_FAILURE,
                        response.data.message
                    )
                );
                if (failure) {
                    failure(response.data.message);
                }
            }
        },
        (error) => {
            dispatch(
                FAILURE(ANNOUNCEMENTS_ACTION_TYPE.REMOVE_FAILURE, error.message)
            );
            if (failure) {
                failure(error?.response?.data?.message || "Failed to Update");
            }
        }
    );
};
